/// <reference path="./TypeLite.Net4.d.ts" />
import { AppConfig } from './appConfig';

export interface ResourceTranslation {
    Key: string;
    Value: string;
}

export interface ResourceNamespace {
    Name: string;
    Translations: ResourceTranslation[];
}

export interface IDictionaryDataResource {
    [key: string]: ResourceTranslation;
}

export class ResourceProvider {
	private static keyedResources: IDictionaryDataResource;

	public static getText = (code: string, namespaceKey?: string): string => {
		if (ResourceProvider.keyedResources) {
			let key: string;
			if (namespaceKey) {
				key = namespaceKey + '.' + code;
			} else {
				key = AppConfig.TranslationNamespaces.Default + '.' + code;
			}

			var item = ResourceProvider.keyedResources[key];

			if (item)
				return item.Value;
		} 

		// default result for not found resource is code itself
		return `#${code}`;
	};

    static loadResources = (dataResourceUrl?: string): Promise<void> => {
        ResourceProvider.keyedResources = {};
        return fetch(dataResourceUrl ? dataResourceUrl : `${ResourceProvider.appendIfNotEndsWith(window.location.href.split('?')[0], '/')}api/Resource/GetDataResources`,
            { method: 'GET' })
            .then((response: Response) => {
                return response.json().then((data) => {
                    let namespaces: ResourceNamespace[] = data;

                    if (namespaces) {
                        namespaces.forEach(namespace => {
                            namespace.Translations.forEach(translation => {
                                if (ResourceProvider.keyedResources[namespace.Name + '.' + translation.Key] === undefined) {
                                    ResourceProvider.keyedResources[namespace.Name + '.' + translation.Key] = translation;
                                }
                            });
                        });
                    }
                })
            });
    };

    static appendIfNotEndsWith(value: string, charToAppend: string) {
        if (value.indexOf(charToAppend, value.length - charToAppend.length) !== -1) {
            return value;
        }
        return value + charToAppend;
    }
}